<script setup lang="ts">
import { useSearchContext } from '../composables/searchContext';
const search = useSearchContext();
</script>

<template>
  <section id="InformationResultDiv" aria-label="Information results">
    <article v-for="item in search.informationResults.value" :key="`${item.TabUrl}-${item.TabName}`" class="cms">
      <div class="cnt"><h4 class="info-h4"><a :href="item.TabUrl">{{ item.TabName }}</a></h4><h3 class="info-h3">{{ item.TabDescription }}</h3></div>
    </article>
  </section>
</template>
